import React, { useState } from "react";
import PageWrapper from "../../Atoms/PageWrapper";
import FlexWrapper from "../../Atoms/FlexWrapper";
import { Colors } from "../../Utils/Colors";
import Typography from "../../Atoms/Typography";
import { Link } from "react-router-dom";
import GetInTouch from "../../Template/GetInTouch";
import MarginWrapper from "../../Atoms/MarginWrapper";
import { isMobile } from "../../Utils/IsMobile";

const Footer = () => {
  const quickLinks = [
    { title: "Home", link: "/" },
    { title: "About Zeit Systems", link: "/about" },
     { title: "Projects", link: "/projects" },
    { title: "Contact Us", link: "/contact" },
  ];

  const services = [
    { title: "Factory Automation", link: "/services/factory-automation" },
    { title: "Internet of Things", link: "/services/iot" },
    {
      title: "IoT Specialized Software development",
      link: "/services/iot-software",
    },
    { title: "Machine Vision", link: "/services/machine-vision" },
    { title: "Robotics", link: "/services/robotics" },
    { title: "SPM Manufacturing", link: "/services/spm" },
    { title: "Sales", link: "/services/sales" },
  ];

  const HoverText = ({ text }) => {
    const [isHover, setHover] = useState(false);
    return (
      <div
        style={{
          fontSize: "0.875rem",
          fontWeight: "700",
          textDecoration: isHover ? "underline" : "none",
          color: "#FFF",
          textDecorationColor: Colors.yellow,
          textUnderlinePosition: "under",
          textUnderlineOffset: "2px",
          cursor: "pointer",
          transition: "all 0.3s ease",
          padding: "0.25rem 0",
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {text}
      </div>
    );
  };

  const SectionTitle = ({ name }) => {
    return (
      <div style={{ marginBottom: "1.5rem" }}>
        <Typography
          text={name}
          color={Colors.White}
          sizeAndWeight={"1.125rem-700"}
          style={{
            borderBottom: `2px solid ${Colors.yellow}`,
            paddingBottom: "0.5rem",
            display: "inline-block"
          }}
        />
      </div>
    );
  };

  if (isMobile) {
    return (
      <div
        style={{
          background: Colors.BigStone,
          padding: "40px 20px",
        }}
      >
        <PageWrapper>
          <FlexWrapper flexDirection="column" gap={"40px"}>
            {/* Quick Links */}
            <div>
              <SectionTitle name="Quick Links" />
              <FlexWrapper flexDirection="column" gap={"1rem"}>
                {quickLinks.map((data) => (
                  <Link key={data.link} to={data.link} style={{ textDecoration: "none" }}>
                    <HoverText text={data.title} />
                  </Link>
                ))}
              </FlexWrapper>
            </div>

            {/* Services */}
            <div>
              <SectionTitle name="Services" />
              <FlexWrapper flexDirection="column" gap={"1rem"}>
                {services.map((data) => (
                  <Link key={data.link} to={data.link} style={{ textDecoration: "none" }}>
                    <HoverText text={data.title} />
                  </Link>
                ))}
              </FlexWrapper>
            </div>

            {/* Get in Touch */}
            <GetInTouch />
          </FlexWrapper>
        </PageWrapper>
      </div>
    );
  }

  const isTablet = window.innerWidth <= 1024;

  return (
    <div
      style={{
        background: Colors.BigStone,
        padding: "60px 0",
      }}
    >
      <PageWrapper>
        <FlexWrapper
          flexDirection="row"
          justifyContent="space-between"
          alignItems="flex-start"
          gap={"40px"}
          style={{ flexWrap: "wrap" }}
        >
          {/* Quick Links Section */}
          <div style={{ flex: isTablet ? "1 1 200px" : "0 0 200px" }}>
            <SectionTitle name="Quick Links" />
            <FlexWrapper flexDirection="column" gap={"1rem"}>
              {quickLinks.map((data) => (
                <Link key={data.link} to={data.link} style={{ textDecoration: "none" }}>
                  <HoverText text={data.title} />
                </Link>
              ))}
            </FlexWrapper>
          </div>

          {/* Services Section */}
          <div style={{ flex: isTablet ? "1 1 350px" : "0 0 350px" }}>
            <SectionTitle name="Services" />
            <FlexWrapper flexDirection="column" gap={"1rem"}>
              {services.map((data) => (
                <Link key={data.link} to={data.link} style={{ textDecoration: "none" }}>
                  <HoverText text={data.title} />
                </Link>
              ))}
            </FlexWrapper>
          </div>

          {/* Get in Touch Section - Takes more space */}
          <div style={{ flex: isTablet ? "1 1 350px" : "0 0 400px" }}>
            <GetInTouch />
          </div>
        </FlexWrapper>

        {/* Bottom Copyright Section */}
        <MarginWrapper mt={"60px"} style={{ borderTop: `1px solid rgba(255,255,255,0.1)` }}>
          <FlexWrapper
            justifyContent="space-between"
            alignItems="center"
            style={{ paddingTop: "20px" }}
          >
            <Typography
              text={`© ${new Date().getFullYear()} Zeit Systems. All rights reserved.`}
              color={Colors.White}
              sizeAndWeight={"0.875rem-400"}
            />
          </FlexWrapper>
        </MarginWrapper>
      </PageWrapper>
    </div>
  );
};

export default Footer;